/* Spinningstickers: textfält för "Custom Color" (fälgdekaler och kit).
   När vald variant har Color = "Custom Color" visas ett obligatoriskt fält
   "Vilken/vilka färger vill du ha?" som skickas som radegenskapen
   properties[Custom color] (form-attributet kopplar fältet till produktformuläret).
   Köp-knappen stoppas i capture-fasen (som ss-dod.js) tills fältet är ifyllt (och
   "ss:varukorg-stoppad" skickas till besöksmätningen i ss-umami.liquid), och
   snabbkassan göms medan Custom Color är vald eftersom den kringgår kontrollen.
   Vald variant läses ur formulärets dolda name="id" och slås upp mot
   /products/<handle>.js UTAN språkprefix — då är optionsnamn/värden alltid engelska,
   oavsett hur sidans optioner är översatta och hur ss-finish-picker.js ritar om väljaren. */
(function () {
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var HANDLE = decodeURIComponent(m[1]);
  var PROP = "properties[Custom color]";
  var ALLA_TXT = {
    en: { label: "Which color(s) do you want?", hint: "E.g. matte black and red, or a RAL/Pantone code.", missing: "Please tell us which color(s) you want." },
    sv: { label: "Vilken/vilka färger vill du ha?", hint: "T.ex. mattsvart och röd, eller en RAL-/Pantone-kod.", missing: "Skriv vilken eller vilka färger du vill ha." },
    fr: { label: "Quelle(s) couleur(s) souhaitez-vous ?", hint: "Par ex. noir mat et rouge, ou un code RAL/Pantone.", missing: "Veuillez indiquer la ou les couleurs souhaitées." },
    de: { label: "Welche Farbe(n) möchtest du?", hint: "Z. B. Mattschwarz und Rot oder ein RAL-/Pantone-Code.", missing: "Bitte gib an, welche Farbe(n) du möchtest." },
    es: { label: "¿Qué color(es) quieres?", hint: "P. ej. negro mate y rojo, o un código RAL/Pantone.", missing: "Indica qué color(es) quieres." },
    it: { label: "Quale/i colore/i desideri?", hint: "Ad es. nero opaco e rosso, oppure un codice RAL/Pantone.", missing: "Indica quale/i colore/i desideri." },
    nl: { label: "Welke kleur(en) wil je?", hint: "Bijv. matzwart en rood, of een RAL-/Pantone-code.", missing: "Geef aan welke kleur(en) je wilt." }
  };
  var TXT = ALLA_TXT[(document.documentElement.lang || "en").slice(0, 2).toLowerCase()] || ALLA_TXT.en;
  var custom = {};   // variant-id -> true om Color = "Custom Color"

  function forms() {
    return Array.prototype.filter.call(document.querySelectorAll('form[data-type="add-to-cart-form"]'), function (f) {
      return f.getAttribute("id") && !f.closest("quick-add-modal, .quick-add");
    });
  }
  function variantId(form) {
    var i = form.querySelector('input[name="id"], select[name="id"]');
    return i ? String(i.value) : "";
  }

  function build(form) {
    // OBS: form.id är fältet name="id", inte id-attributet (se ss-dod.js).
    var formId = form.getAttribute("id");
    var box = document.createElement("div");
    box.className = "product-form__input ss-dod-field ss-dod-color ss-cc";
    box.hidden = true;
    box.innerHTML = '<label class="form__label"></label><div class="field"><input class="field__input" type="text" maxlength="200" autocomplete="off"></div><div class="ss-dod-hint"></div><div class="ss-dod-msg" hidden></div>';
    var inp = box.querySelector("input");
    inp.id = "ss-cc-" + formId;
    inp.name = PROP;
    inp.setAttribute("form", formId);
    inp.disabled = true;   // skickas inte med förrän Custom Color är vald
    var lab = box.querySelector("label");
    lab.textContent = TXT.label + " *";
    lab.setAttribute("for", inp.id);
    box.querySelector(".ss-dod-hint").textContent = TXT.hint;
    var msg = box.querySelector(".ss-dod-msg");
    inp.addEventListener("input", function () { msg.hidden = true; });

    form.addEventListener("submit", function (e) {
      if (box.hidden || inp.value.trim()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      try { document.dispatchEvent(new CustomEvent("ss:varukorg-stoppad", { detail: { orsak: "farg", form: form } })); } catch (x) {}
      msg.textContent = TXT.missing; msg.hidden = false;
      box.scrollIntoView({ block: "center", behavior: "smooth" });
      inp.focus({ preventScroll: true });
    }, true);

    var info = form.closest(".product__info-container") || document;
    var anchor = info.querySelector(".product-form__quantity") || form;
    anchor.parentNode.insertBefore(box, anchor);
    form._ssCC = { box: box, inp: inp, msg: msg };
  }

  function update() {
    var any = false;
    forms().forEach(function (f) {
      if (!f._ssCC || !f._ssCC.box.isConnected) build(f);
      var c = f._ssCC, on = !!custom[variantId(f)];
      if (on) any = true;
      if (c.box.hidden === !on) return;
      c.box.hidden = !on;
      c.inp.disabled = !on;
      c.inp.required = on;
      if (!on) c.msg.hidden = true;
    });
    document.documentElement.classList.toggle("ss-cc-active", any);
  }
  var t = null;
  function later() {
    update();
    clearTimeout(t);
    t = setTimeout(update, 400);   // Ride byter variant-id efter sin sektionshämtning
  }

  function start() {
    fetch("/products/" + encodeURIComponent(HANDLE) + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p || !p.options) return;
      var ci = -1;
      p.options.forEach(function (o, i) { if ((typeof o === "string" ? o : o.name) === "Color") ci = i; });
      if (ci < 0) return;
      var n = 0;
      p.variants.forEach(function (v) {
        if ((v.options[ci] || "").trim() === "Custom Color") { custom[String(v.id)] = true; n++; }
      });
      if (!n) return;
      update();
      document.addEventListener("change", later, true);
      document.addEventListener("click", function (e) {
        if (e.target.closest && e.target.closest("variant-selects, .ss-color, .ss-finish")) later();
      }, true);
      setInterval(update, 1000);   // skyddsnät: variantbyte via galleriet m.m.
    }).catch(function () {});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
